// extracted by mini-css-extract-plugin
export var active = "_87-2";
export var container = "_87-0";
export var expired = "_87-3";
export var hasStatus = "_87-4";
export var statusChip = "_87-1";